import React, { useEffect, useRef, useState } from "react"
import { useLocation } from '@reach/router'
import { useTheme }  from '~/contexts/ThemeContext'
import { notBlank, jnstyls } from '~/utils/helpers'

import HomeImg from './home-img'
import { Title, Subtitle, Ctas, Body } from './contents'

import * as styles from "~/styles/home/journal.module.scss"
import { hjourn } from "~/styles/home/hero.module.scss"
import { fhjourn } from "~/styles/home/full-bleed.module.scss"

const Journal = ({ block, index, blog=false }) => {
  const location = useLocation()
  const { gender } = useTheme()
  const { align, image, contents, url, vid_handle } = !blog ? block : block.settings

  const [isPreview, setIsPreview] = useState(false)

  const journRef = useRef(null)

  const img_obj = {image: image, url: url, vid_handle: vid_handle}
  const has_cta = contents.find(x => x.type === 'cta')

  if (has_cta && notBlank(url)) {
    has_cta.links.forEach(x => x.url = url)
  }

  const check_show = () => {
    if (blog) return true
    if (!isPreview) {
      return gender.pgGender === block.gender && (notBlank(image) || notBlank(vid_handle))
    }
    return notBlank(image) || notBlank(vid_handle)
  }

  useEffect(() => {
    if (location.pathname.includes('/preview/')) setIsPreview(true)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div 
      className={jnstyls([styles.nd_journ, hjourn, fhjourn])} 
      mok-block={index}
      g={block.gender}
      ref={journRef}
      mid={block.id}
      bbloc={blog ? '' : undefined}
    >
      <div className={`${styles.content} ${align && align === 'right' ? styles.jour_right : ''}`}>
        <div className={styles.image}>
          {check_show() && (
            <HomeImg 
              item={img_obj} 
              show_mobile={true} 
              index={index} 
              pstyles={styles} 
              block={block}
            />
          )}
        </div>
        <div className={styles.copy}>
          {!!contents && contents.map((content, contIndex) => {
            switch (content.type) {
              case 'title':
                return (
                  <Title 
                    block={block} 
                    key={`journ${index}-${contIndex}`} 
                    item={content} 
                    index={index} 
                    pstyles={styles} 
                  />
                )
              case 'subtitle':
                return (
                  <Subtitle 
                    block={block} 
                    key={`journ${index}-${contIndex}`} 
                    item={content} 
                    index={index} 
                    pstyles={styles} 
                  />
                )
              case 'body':
                return (
                  <Body 
                    block={block} 
                    key={`journ${index}-${contIndex}`} 
                    copy={content.copy} 
                    index={index} 
                    pstyles={styles} 
                  />
                )
              case 'cta':
                return (
                  <Ctas 
                    block={block} 
                    key={`journ${index}-${contIndex}`} 
                    item={content} 
                    index={index} 
                    pstyles={styles} 
                  />
                )
              default:
                return <React.Fragment key={`journ${index}-${contIndex}`} />
            }
          })}
        </div>
      </div>
    </div>
  )
}



export default Journal



